import type { Config } from "@jti/fe-common";
import type { PostCodeConfig } from "@jti/magento";
import type { StoreConfig } from "@jti/store/slices/magentoApiSlice";

export const prepareMagentoPostCodeConfig = (storeConfig: StoreConfig, globalConfig: Config): PostCodeConfig => {
  const postcodeValidationEnabled = storeConfig?.postcodeValidationEnabled ?? false;
  const postcodeIsRequired = storeConfig?.postcodeIsRequired ?? true;
  const postcodeMaxLength = storeConfig?.postcodeMaxLength ?? 0;
  const postcodeMinLength = storeConfig?.postcodeMinLength ?? 0;
  const postcodeValidateRegex = storeConfig?.postcodeValidateRegex ?? "";
  const shouldHidePostCode = /true/i.test(globalConfig.HIDE_POST_CODE_INPUT) && !postcodeIsRequired;

  return {
    postcode_is_required: postcodeIsRequired,
    postcode_max_length: postcodeMaxLength,
    postcode_min_length: postcodeMinLength,
    postcode_validate_regex: postcodeValidateRegex,
    postcode_validation_enabled: postcodeValidationEnabled,
    shouldHidePostCode,
    postCodeKeyboardType: globalConfig.postCodeKeyboardType ?? "default",
  };
};
